module.exports = __webpack_public_path__ + "static/img/important4.50a6a92.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/important4.png
// module id = 9qi8
// module chunks = 1